<script setup>
import {ref, onBeforeUnmount, onBeforeMount} from "vue";
import axios from "axios";
import store from "@/store/store";
import {format} from "date-fns";

const props = defineProps({
  request_id: "",
  manager_id: "",
  request_statuses: { type: Array, default: () => [] },
  fitters_list: { type: Array, default: () => [] },
  // engineers_list: { type: Array, default: () => [] },
  managers_list: { type: Array, default: () => [] },
  areas_streets_array: { type: Array, default: () => [] },
  request_kinds_types_array: { type: Array, default: () => [] },
});
const emit = defineEmits(['refresh-requests']);

let is_manager = ref();
let abonent = ref();
let is_superuser = ref();
const is_completed = ref(false);
const disconnection_internet = ref(["9ea1b162-ebcd-428d-91e1-a5ce26ddeaeb", "c3dd69ab-df15-446f-9261-0e52d4e6737d"])
let changeFitter = ref(false)
let request_statuses = ref([])
let selected_fields = ref({
  selected_status: {
    id: '',
    name: ''
  },
  selected_fitter: {
    fitter_id: '',
    fitter_name: ''
  },
  selected_manager: {
    manager_id: '',
    manager_name: ''
  },
  // selected_engineer: {
  //   engineer_id: '',
  //   engineer_name: '',
  // },
  manager_comment: '',
  selected_request_type: {
    type_id: '',
    type_name: ''
  },
  selected_request_kind: {
    kind_id: '',
    kind_name: ''
  },
  selected_area: {
    area_id: '',
    area_name: ''
  },
  selected_street: {
    street_id: '',
    street_name: ''
  },
  selected_house: {
    house_id: '',
    house_number: ''
  },
  selected_flat: {
    client_id: '',
    lastname: '',
    firstname: '',
    middlename: '',
    phonenumber: '',
    flat_number: '',
    is_internet:"",
    is_phone:"",
    is_tv:"",
    is_intercom:"",
    is_video_sur:"",
  }
});

const form_data = ref({
  id: '',
  username: '',
  selected_fields: '',
  client_name: '',
  client_firstname: '',
  client_lastname: '',
  client_middlename: '',
  client_phone: '',
  client_address: '',
  area: '',
  street: '',
  house: '',
  flat: '',
  request_status_id: '',
  request_status_name: '',
  request_type: '',
  request_type_id: '',
  request_kind: '',
  request_kind_id: '',
  manager_id: '',
  manager_name: '',
  manager_comment: '',
  // engineer_id: '',
  // engineer_name: '',
  fitter_id: '',
  fitter_name: '',
  fitter_comment: '',
  date_accepted: "",
  date_created: "",
  date_completed: "",
  date_closed: "",
  date_expire8: "",
  date_expire48: ""
});

const fetchRequest = async () => {
  try {
    const res = await axios.get('request_details/', {
      params: {
        request_id: props.request_id,
      }
    });
    if (res.data) {
      const data = res.data;
      form_data.value.id = data.id;
      form_data.value.username = data.username;

      form_data.value.request_status_id = data.request_status_id;
      form_data.value.request_status_name = data.request_status_name;
      selected_fields.value.selected_status.id = data.request_status_id;
      selected_fields.value.selected_status.name = data.request_status_name;

      form_data.value.client_id = data.client_id;
      selected_fields.value.selected_flat.client_id = data.client_id;

      form_data.value.client_firstname = data.client_firstname;
      selected_fields.value.selected_flat.firstname = data.client_firstname;

      form_data.value.client_lastname = data.client_lastname;
      selected_fields.value.selected_flat.lastname = data.client_lastname;

      form_data.value.client_middlename = data.client_middlename;
      selected_fields.value.selected_flat.middlename = data.client_middlename;

      form_data.value.client_phone = data.client_phone;
      selected_fields.value.selected_flat.phonenumber = data.client_phone;

      form_data.value.client_address = data.client_address;

      form_data.value.area = data.area;
      selected_fields.value.selected_area.area_id = data.areaid;
      selected_fields.value.selected_area.area_name = data.area;

      form_data.value.street = data.street;
      selected_fields.value.selected_street.street_id = data.street_id;
      selected_fields.value.selected_street.street_name = data.street;

      form_data.value.house = data.house;
      selected_fields.value.selected_house.house_id = data.house_id;
      selected_fields.value.selected_house.house_number = data.house;

      form_data.value.flat = data.flat;
      selected_fields.value.selected_flat.flat_number = data.flat;

      form_data.value.request_type_id = data.request_type_id;
      form_data.value.request_type = data.request_type;
      selected_fields.value.selected_request_type.type_id = data.request_type_id;
      selected_fields.value.selected_request_type.type_name = data.request_type;

      form_data.value.request_kind_id = data.request_kind_id
      form_data.value.request_kind = data.request_kind;
      selected_fields.value.selected_request_kind.kind_id = data.request_kind_id
      selected_fields.value.selected_request_kind.kind_name = data.request_kind;

      form_data.value.manager_id = data.manager_id;
      form_data.value.manager_name = data.manager_name;
      form_data.value.manager_comment = data.manager_comment;
      selected_fields.value.selected_manager.manager_id = data.manager_id;
      selected_fields.value.selected_manager.manager_name = data.manager_name
      selected_fields.value.manager_comment = data.manager_comment;

      // form_data.value.engineer_id = data.engineer_id;
      // form_data.value.engineer_name = data.engineer_name;
      // selected_fields.value.selected_engineer.engineer_id = data.engineer_id;
      // selected_fields.value.selected_engineer.engineer_name = data.engineer_name;

      form_data.value.fitter_id = data.fitter_id;
      form_data.value.fitter_name = data.fitter_name;
      selected_fields.value.selected_fitter.fitter_id = data.fitter_id;
      selected_fields.value.selected_fitter.fitter_name = data.fitter_name;

      form_data.value.fitter_comment = data.fitter_comment;
      form_data.value.date_created = data.date_created;
      form_data.value.date_closed = data.date_closed;
      form_data.value.date_accepted = data.date_accepted;
      form_data.value.date_completed = data.date_completed;

      selected_fields.value.selected_flat.is_phone = data.is_phone;
      selected_fields.value.selected_flat.is_tv = data.is_tv;
      selected_fields.value.selected_flat.is_internet = data.is_internet;
      selected_fields.value.selected_flat.is_intercom = data.is_intercom;
      selected_fields.value.selected_flat.is_video_sur = data.is_video_sur;
      request_statuses.value =
          [
          // { "id": 1, "name": "В работе", "is_active": true },
          // { "id": 2, "name": "Назначен инженер", "is_active": false },
          // { "id": 3, "name": "Назначен монтёр", "is_active": false },
          // { "id": 4, "name": "Принял в работу монтёр", "is_active": true },
          // { "id": 5, "name": "Отмена, по просьбе абонента" },
          // { "id": 6, "name": "Переназначен монтёр", "is_active": false },
          // { "id": 7, "name": "Заявка просрочена", "is_active": true },
          // { "id": 8, "name": "Просрочена 48", "is_active": true },
          // { "id": 9, "name": "Авария", "is_active": true },
          // { "id": 10, "name": "После аварии" },
          // { "id": 11, "name": "Перезапущен после аварии", "is_active": true },
          // { "id": 12, "name": "Выполнен монтёром" }
          { "id": 13, "name": "Выполнено", "is_active": true },
          // { "id": 14, "name": "Не выполнено, по вине абонента" },
          // { "id": 15, "name": "Не выполнено, по вине монтёра", "is_active": false }
          ]
    } else {
      console.error('No data found for this request.');
    }
  } catch (err) {
    console.error('Error fetching request:', err);
  }
}

const editRequest = async () => {
  try {
    const payload = {
      request_id: props.request_id,
      request_status_id: selected_fields.value.selected_status.id,
      manager_comment: selected_fields.value.manager_comment,
      request_type_id: selected_fields.value.selected_request_type.type_id,
      request_kind_id: selected_fields.value.selected_request_kind.kind_id,
    };

    if (changeFitter.value === true) {
      payload.fitter_id = selected_fields.value.selected_fitter.fitter_id;
    } else {
      payload.phone_number = selected_fields.value.selected_flat.phonenumber;
    }
    await axios.put('request_details/', payload);
    resetSelectedFields();
    emit('refresh-requests')
    // closeModal();
    // window.location.reload();

  } catch (error) {
    alert(error.message);
    console.log(error.response);
  }
}
const resetSelectedFields = () => {
  selected_fields.value = {
    selected_status: {
      id: '',
      name: ''
    },
    selected_fitter: {
      fitter_id: '',
      fitter_name: ''
    },
    fitter_comment: '',
    selected_manager: {
      manager_user_id: '',
      manager_name: ''
    },
    // selected_engineer: {
    //   engineer_id: '',
    //   engineer_name: '',
    // },
    manager_comment: '',
    selected_request_type: {
      type_id: '',
      type_name: ''
    },
    selected_request_kind: {
      kind_id: '',
      kind_name: ''
    },
    selected_area: {
      area_id: '',
      area_name: ''
    },
    selected_street: {
      street_id: '',
      street_name: ''
    },
    selected_house: {
      house_id: '',
      house_number: ''
    },
    selected_flat: {
      client_id: '',
      lastname: '',
      firstname: '',
      middlename: '',
      phonenumber: '',
      flat_number: ''
    }
  };
};

// Open modal function
const openModal = () => {
  if(!is_manager){
    alert("Недостаточно прав!")
    return
  }
  const modal = new bootstrap.Modal(document.getElementById('edit_request_manager_' + props.request_id));
  modal.show();
  history.pushState({modalOpen: true}, '');
};

// Close modal function
const closeModal = () => {
  const modal = bootstrap.Modal.getInstance(document.getElementById('edit_request_manager_' + props.request_id));
  if (modal) {
    modal.hide();
    history.replaceState(null, null); // Clean history
  }
};

// Handle popstate event
const handlePopState = (event) => {
  if (event.state && event.state.modalOpen) {
    closeModal();
  } else {
    history.replaceState(null, null);
  }
};

// Add event listener for popstate
// window.addEventListener('popstate', handlePopState);

const fetchData = () => {
  fetchRequest();
  // fetchRequestFields();
};

const formattedTimestamp = (datetime) => {
  // console.log(datetime);
  if (!datetime) return "Invalid Date"; // Handle null or undefined datetime

  const date = new Date(datetime);
  if (isNaN(date.getTime())) return "Invalid Date"; // Check if the date is invalid

  return format(date, 'dd/MM/yyyy, HH:mm'); // Safe formatting
};
onBeforeMount(()=>{

  is_manager = store.getters['profile/is_manager'];
  abonent = store.getters['profile/abonent'];
  is_superuser = store.getters['profile/is_superuser'];
})
onBeforeUnmount(() => {
  // Remove the event listener when the component is destroyed
  window.removeEventListener('popstate', handlePopState);
});
</script>

<template>
  <div>
    <!-- Button to show modal -->
    <div
        v-if="(is_manager && abonent === props.manager_id) || is_superuser"
        class="cursor-pointer"
        data-bs-toggle="modal"
        :href="'#edit_request_manager_'+props.request_id"
        @click="fetchData()"
    >
      <i class="fas fa-edit fs-4 text-primary"></i>
    </div>

    <!-- Modal Component -->
    <div class="modal fade" :id="'edit_request_manager_'+props.request_id" data-bs-backdrop="static" data-bs-keyboard="false">
      <div class="modal-dialog modal-dialog-scrollable modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-light">
            <h4 class="modal-title text-bold">Редактирование заявки</h4>
<!--            <select-->
<!--                class="form-select form-select-sm ms-5 me-5"-->
<!--                v-model="selected_fields.selected_status"-->
<!--            >-->
<!--              <option selected disabled>{{ form_data.request_status_name }}</option>-->
<!--              <option-->
<!--                  v-for="status in request_statuses"-->
<!--                  :value="status"-->
<!--                  :key="status.id"-->
<!--                  :class="status.name === form_data.name ? ['disabled']:''"-->
<!--              >-->
<!--                {{ status.name }}-->
<!--              </option>-->
<!--            </select>-->
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row d-flex justify-content-evenly g-1">
              <div class="col">
                <div class="timeline-wrapper">
                  <div>
                    <div class="d-flex flex-row g-3">
                      <div class="timeline-item col">
                        <div class="timeline-icon bg-dark text-white">
                          <i class="bi bi-file-earmark-plus"></i>
                        </div>
                        <div class="timeline-content">
                          <h6 class="mb-1">Заявка создана</h6>
                          <p class="timeline-date">{{ formattedTimestamp(form_data.date_created) }}</p>
                          <p class="timeline-description">{{ form_data.manager_name || 'Неизвестный менеджер' }}</p>
                        </div>
                      </div>
                      <div class="timeline-item col" v-if="form_data.date_accepted">
                        <div class="timeline-icon bg-primary text-white">
                          <i class="bi bi-person-check"></i>
                        </div>
                        <div class="timeline-content">
                          <h6 class="mb-1">Принята монтёром</h6>
                          <p class="timeline-date">{{ formattedTimestamp(form_data.date_accepted) }}</p>
                          <p class="timeline-description">{{ form_data.fitter_name || 'Неизвестный монтёр' }}</p>
                        </div>
                      </div>

                      <div class="timeline-item col" v-if="form_data.request_status_id === '12' || form_data.request_status_id === '13'">
                        <div class="timeline-icon bg-info text-white">
                          <i class="bi bi-tools"></i>
                        </div>
                        <div class="timeline-content">
                          <h6 class="mb-1">Выполнена монтёром</h6>
                          <p class="timeline-date">{{ formattedTimestamp(form_data.date_completed) }}</p>
                          <p class="timeline-description">{{ form_data.fitter_name || 'Неизвестный монтёр' }}</p>
                        </div>
                      </div>

                      <div class="timeline-item col" v-if="form_data.date_closed">
                        <div class="timeline-icon bg-success text-white">
                          <i class="bi bi-check2-circle"></i>
                        </div>
                        <div class="timeline-content">
                          <h5 class="mb-1">Заявка закрыта</h5>
                          <p class="timeline-date">{{ formattedTimestamp(form_data.date_closed) }}</p>
                          <p class="timeline-description">{{ form_data.manager_name || 'Неизвестный менеджер' }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-if="selected_fields.selected_area">
              <div class="col-12">
                <label class="form-label">Адрес:</label>
                <p class="form-control-static" >
                  {{ selected_fields.selected_street.street_name }}
                  {{ selected_fields.selected_house.house_number }},
                  квартира {{ selected_fields.selected_flat.flat_number }}
                </p>
              </div>
            </div>

            <div v-if="selected_fields.selected_flat">
              <div class="row">
                <div class="col-12 col-md-4">
                  <label class="form-label">ФИО абонента:</label>
                  <p>{{ selected_fields.selected_flat.lastname }} {{ selected_fields.selected_flat.firstname }} {{ selected_fields.selected_flat.middlename }}</p>
                </div>
                <div class="col-12 col-md-4">
                  <label class="form-label">Телефон:</label>
                  <p
                    v-if="form_data.request_status_id==='4' || form_data.request_status_id==='12'"
                  >
                    {{selected_fields.selected_flat.phonenumber}}
                  </p>
                  <input
                    v-else
                    type="text" class="form-control"
                    v-model="selected_fields.selected_flat.phonenumber"
                    required
                  >
                </div>
              </div>
            </div>
            <div class="row" v-if="form_data.request_status_id==='4' || form_data.request_status_id==='12'">
              <div class="col-12 col-md-5">
                <label class="form-label">Вид:</label>
                <select class="form-select" disabled>
                  <option>{{ form_data.request_type }}</option>
                </select>
              </div>
              <div class="col-12 col-md-5">
                <div>
                  <label class="form-label">Причина:</label>
                  <select
                      class="form-select" disabled
                  >
                    <option selected disabled>{{ form_data.request_kind }}</option>
<!--                    <option-->
<!--                        :disabled="(!selected_fields.selected_request_type) || selected_fields.selected_request_type === form_data.request_kind"-->
<!--                        v-for="kind in selected_fields.selected_request_type.kinds"-->
<!--                        :key="kind.kind_id"-->
<!--                        :value="kind"-->
<!--                    >-->
<!--                      {{ kind.kind_name }}-->
<!--                    </option>-->
                  </select>
                </div>
              </div>
            </div>
            <div v-else class="row">
              <div class="col-12 col-md-5">
                <label class="form-label">Вид:</label>
                <select
                    class="form-select"
                    v-model="selected_fields.selected_request_type"
                    :disabled="form_data.request_status_id==='12'"
                >
                  <option selected disabled>{{ selected_fields.selected_request_type.type_name }}</option>
                  <option
                      v-for="type in request_kinds_types_array"
                      :value="type"
                      :key="type.type_id"
                  >
                    {{ type.type_name }}
                  </option>
                </select>
              </div>
              <div class="col-12 col-md-5">
                <div v-if="selected_fields.selected_request_type">
                  <label class="form-label">Причина:</label>
                  <select
                      class="form-select"
                      v-model="selected_fields.selected_request_kind"
                      :disabled="form_data.request_status_id==='12'"
                  >
                    <option selected disabled>{{ form_data.request_kind }}</option>
                    <option
                        :disabled="(!selected_fields.selected_request_type) || selected_fields.selected_request_type === form_data.request_kind"
                        v-for="kind in selected_fields.selected_request_type.kinds"
                        :key="kind.kind_id"
                        :value="kind"
                    >
                      {{ kind.kind_name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div
                class="row mb-3"
            >
              <div
                  class="col-12"
                  v-if="
                  (selected_fields.selected_request_type.type_id === 'd283461c-09b4-430d-b5bd-eba2033ecc54' || selected_fields.selected_request_type.type_id === '754a15de-c6c9-448a-8487-e94bab389ace') && selected_fields.selected_flat.client_id !== null"
              >
                <div class="d-flex flex-wrap gap-2">
                  <label class="h4 w-100">Выберите услуги на отключение:</label>
                  <!-- Internet -->
                  <button
                      type="button"
                      class="btn d-flex align-items-center gap-2"
                      :class="{
                        'btn-success': selected_fields.selected_flat.is_internet,
                        'btn-danger': !selected_fields.selected_flat.is_internet
                      }"
                      @click.prevent="selected_fields.selected_flat.is_internet = !selected_fields.selected_flat.is_internet"
                  >
                    <i class="fas fa-wifi"></i>
                    <span>Интернет</span>
                  </button>

                  <!-- Intercom -->
                  <button
                      type="button"
                      class="btn d-flex align-items-center gap-2"
                      :class="{
                        'btn-success': selected_fields.selected_flat.is_intercom,
                        'btn-danger': !selected_fields.selected_flat.is_intercom
                      }"
                      @click.prevent="selected_fields.selected_flat.is_intercom = !selected_fields.selected_flat.is_intercom"
                  >
                    <i class="fas fa-door-closed"></i>
                    <span>Домофон</span>
                  </button>

                  <!-- Video Surveillance -->
                  <button
                      type="button"
                      class="btn d-flex align-items-center gap-2"
                      :class="{
                        'btn-success': selected_fields.selected_flat.is_video_sur,
                        'btn-danger': !selected_fields.selected_flat.is_video_sur
                      }"
                      @click.prevent="selected_fields.selected_flat.is_video_sur = !selected_fields.selected_flat.is_video_sur"
                  >
                    <i class="fas fa-video"></i>
                    <span>Видеонаблюдение</span>
                  </button>

                  <!-- Phone -->
                  <button
                      type="button"
                      class="btn d-flex align-items-center gap-2"
                      :class="{
                        'btn-success': selected_fields.selected_flat.is_phone,
                        'btn-danger': !selected_fields.selected_flat.is_phone
                      }"
                      @click.prevent="selected_fields.selected_flat.is_phone = !selected_fields.selected_flat.is_phone"
                  >
                    <i class="fas fa-phone-alt"></i>
                    <span>Телефония</span>
                  </button>

                  <!-- TV -->
                  <button
                      type="button"
                      class="btn d-flex align-items-center gap-2"
                      :class="{
                        'btn-success': selected_fields.selected_flat.is_tv,
                        'btn-danger': !selected_fields.selected_flat.is_tv
                      }"
                      @click.prevent="selected_fields.selected_flat.is_tv = !selected_fields.selected_flat.is_tv"
                  >
                    <i class="fas fa-tv"></i>
                    <span>Телевидение</span>
                  </button>
                </div>
              </div>
            </div>
            <br>
            <div class="row">
              <div class="col-12 col-md-5">
                <label class="form-label">Менеджер:</label>
                <select class="form-select" disabled>
                  <option selected>{{ selected_fields.selected_manager.manager_name }}</option>
                </select>
              </div>
            </div>
            <div class="row" v-if="!disconnection_internet.includes(selected_fields.selected_request_kind)">
              <div class="col-12 col-md-5">
                <div v-if="form_data.request_status_id==='4' || form_data.request_status_id==='12'">
                  <label class="form-label">Монтёр</label>
                  <select
                      class="form-select"
                      :disabled="!changeFitter"
                  >
                    <option>{{ form_data.fitter_name }}</option>
                  </select>
                </div>

                <div v-else>
                  <label class="form-label">Переназначить монтёра?</label>
                  <input type="checkbox" class="ml-2 form-check-input" v-model="changeFitter">
                  <select
                      class="form-select" v-model="selected_fields.selected_fitter" required
                      :disabled="!changeFitter"
                  >
                    <option
                        v-for="fitter in fitters_list"
                        :key="fitter.fitter_id"
                        :value="fitter"
                        :disabled="form_data.fitter_name === fitter.fitter_name"
                    >
                      {{ fitter.fitter_name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="container">
              <div>
                <label class="form-label">Комментарий менеджера:</label>
                <textarea
                    required
                    class="form-control"
                     v-model="selected_fields.manager_comment"
                >
                  {{ selected_fields.manager_comment }}
                </textarea>
              </div>
            </div>
            <div class="container">
              <div>
                <label class="form-text">Комментарий монтёра:</label>
                <textarea
                    class="form-control"
                    required
                    v-model="form_data.fitter_comment"
                    disabled
                >
                </textarea>
              </div>
            </div>
          </div>
          <div class="modal-footer bg-light">
            <div class="container d-flex justify-content-between align-items-center p-3">
              <!-- Checkbox with a custom-styled label -->
              <div class="form-check form-switch">
                <input
                    class="form-check-input"
                    type="checkbox"
                    :id="`completeRequestCheckbox_`+request_id"
                    @change="selected_fields.selected_status.id = 13;"
                    :disabled="form_data.request_status_id!=='12' && !disconnection_internet.includes(selected_fields.selected_request_kind.kind_id)"
                />
                <label class="form-check-label" for="completeRequestCheckbox">
                  Завершить заявку
                </label>
              </div>

              <!-- Save Changes Button -->
              <button
                  class="btn btn-primary btn-sm"
                  @click="editRequest"
                  type="submit"
                  data-bs-dismiss="modal"
                  aria-label="Close"
              >
                <i class="fas fa-save me-2"></i>Сохранить изменения
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.timeline-item {
  position: relative;
  padding: 0 0 0.5rem 3rem;
  display: flex;
  flex-direction: column;
}

.timeline-item:last-child {
  padding-bottom: 0;
}

.timeline-icon {
  position: absolute;
  left: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  z-index: 1;
  transition: transform 0.3s ease;
}

.timeline-content {
  position: relative;
  padding-left: 15px;
}

.timeline-date {
  font-size: 0.9rem;
  color: #6c757d;
  margin-bottom: 0.25rem;
}

.timeline-description {
  font-size: 1rem;
  color: #495057;
  margin-bottom: 0;
}

.timeline-item:hover .timeline-icon {
  transform: scale(1.1);
}

.cursor-pointer {
  cursor: pointer;
}

.bg-light {
  background-color: #f8f9fa;
}
</style>
